var _defs, _circle, _circle2, _path, _circle3, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOsUbuntu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3.92,
    cy: 9.53,
    r: 2.42
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.97,
    cy: 4.24,
    r: 2.42
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.36,15.75a5.89,5.89,0,0,1-4-3.06,3.48,3.48,0,0,1-2.06.25A7.85,7.85,0,0,0,9,17.69a7.58,7.58,0,0,0,1.71.17,3.48,3.48,0,0,1-.71-2Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.43,
    cy: 15.76,
    r: 2.42
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.79,14.88a7.93,7.93,0,0,0,.4-9.28,3.46,3.46,0,0,1-1.36,1.59,5.93,5.93,0,0,1-.2,5.89A3.45,3.45,0,0,1,16.79,14.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.73,6.07h.18a3.57,3.57,0,0,1,1.83.53,5.9,5.9,0,0,1,4.75-2.54,3.49,3.49,0,0,1,.73-2A7.94,7.94,0,0,0,3.73,6.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsUbuntu);
export default __webpack_public_path__ + "static/media/os-ubuntu.dbf2095e7650c69af02eb83631d013b3.svg";
export { ForwardRef as ReactComponent };